import React, {Component} from "react";
import {Alert, Row, Col, Modal, Button, Card, CardBody, CardFooter} from "reactstrap";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import paginationFactory, {PaginationListStandalone, PaginationProvider, SizePerPageDropdownStandalone} from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {Search,} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {selectModalList, selectModalSelected, selectModalUpdate} from "../../store/components/selectModal/actions";

class SelectModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tableData: [],
      selectedRows: [],
      loadingList: false,
      loadingSelected: false,
      loadingUpdate: false,
      errorList: "",
      errorSelected: "",
      errorUpdate: "",
    }
  }

  componentDidMount() {
    const {onSelectList, onSelectSelected} = this.props;
    onSelectList({history: this.props.history, apiList: this.props.apiList});
    onSelectSelected({history: this.props.history, apiSelected: this.props.apiSelected});
  }

  onClose = () => {
    this.props.togModal()
  }

  onSelect = () => {
    const {onSelectUpdate} = this.props;
    onSelectUpdate({history: this.props.history, apiUpdate: this.props.apiUpdate, selectedRows: this.state.selectedRows});
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        ...this.state,
        tableData: this.props.responseList ? this.props.responseList.response : this.state.tableData,
        selectedRows: this.props.responseSelected ? this.props.responseSelected.response : this.state.selectedRows,
        loadingList: this.props.loadingList,
        loadingSelected: this.props.loadingSelected,
        loadingUpdate: this.props.loadingUpdate,
        errorList: this.props.errorList,
        errorSelected: this.props.errorSelected,
        errorUpdate: this.props.errorUpdate,
      });
      if (this.props.responseUpdate.status === 0) {
        this.props.refreshParent({history: this.props.history})
        this.onClose()
      }
    }
  }

  render() {
    const columns = [{
      dataField: "id", text: "Id", sort: true,
    }, {
      dataField: "name", text: "Name", sort: true,
    }];

    const selectRow = {
      mode: "checkbox",
      clickToSelect: true,
      selected: this.state.selectedRows,
      onSelect: (row, isSelect) => {
        if (isSelect) {
          this.setState(() => ({
            selectedRows: [...this.state.selectedRows, row.id]
          }));
        } else {
          this.setState(() => ({
            selectedRows: this.state.selectedRows.filter(x => x !== row.id)
          }));
        }
      },
      onSelectAll: (isSelect, rows) => {
        const ids = rows.map(r => r.id);
        if (isSelect) {
          this.setState(() => ({
            selectedRows: ids
          }));
        } else {
          this.setState(() => ({
            selectedRows: []
          }));
        }
      }
    };

    const defaultSorted = [{
      dataField: "id", order: "asc",
    },];

    const pageOptions = {
      sizePerPage: 10, totalSize: this.state.tableData.length, custom: true, sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }]
    };

    const {SearchBar} = Search;

    function onColumnMatch({searchText, value, column, row}) {
      if (row.name.toLowerCase().includes(searchText))
        return true
      return false
    }

    return (<React.Fragment>
      <Modal isOpen={true} toggle={this.onClose}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            {this.props.title}
          </h5>
          <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <Card>
          <CardBody>
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={columns}
              data={this.state.tableData}
            >
              {({paginationProps, paginationTableProps}) => (<ToolkitProvider
                keyField="id"
                columns={columns}
                data={this.state.tableData}
                search={{onColumnMatch}}
              >
                {toolkitProps => (<React.Fragment>
                  <Row className="mb-2">
                    <Col md="12">
                      <div className="search-box me-2 mb-2 d-inline-block float-end">
                        <div className="position-relative">
                          <SearchBar {...toolkitProps.searchProps} placeholder="Filter"/>
                          <i className="bx bx-search-alt search-icon"/>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xl="12">
                      <div className="table-responsive">
                        <BootstrapTable
                          keyField={"id"}
                          responsive
                          bordered={false}
                          striped={false}
                          defaultSorted={defaultSorted}
                          selectRow={selectRow}
                          classes={"table align-middle table-nowrap"}
                          headerWrapperClasses={"thead-light"}
                          {...toolkitProps.baseProps}
                          {...paginationTableProps}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="align-items-md-center mt-30">
                    <Col className="inner-custom-pagination d-flex">
                      <div className="d-inline">
                        <SizePerPageDropdownStandalone {...paginationProps}/>
                      </div>
                      <div className="text-md-right ms-auto">
                        <PaginationListStandalone {...paginationProps}/>
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>)}
              </ToolkitProvider>)}
            </PaginationProvider>
          </CardBody>
          <div className="modal-footer">
            {(this.state.loadingList || this.state.loadingSelected || this.state.loadingUpdate) && (<div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>)}
            {(this.state.errorList.length > 0 || this.state.errorSelected.length > 0 || this.state.errorUpdate.length > 0) && (<div className="mt-3">
              <Alert color="danger" role="alert">
                {this.state.errorList} {this.state.errorSelected} {this.state.errorUpdate}
              </Alert>
            </div>)}
            <Button color="primary" onClick={this.onSelect}>
              Select
            </Button>
          </div>
        </Card>
      </Modal>
    </React.Fragment>)
  }
}

SelectModal.propTypes = {
  responseList: PropTypes.any,
  responseSelected: PropTypes.any,
  responseUpdate: PropTypes.any,
};

const mapStateToProps = ({SelectModal}) => ({
  responseList: SelectModal.responseList,
  responseSelected: SelectModal.responseSelected,
  responseUpdate: SelectModal.responseUpdate,
  loadingList: SelectModal.loadingList,
  loadingSelected: SelectModal.loadingSelected,
  loadingUpdate: SelectModal.loadingUpdate,
  errorList: SelectModal.errorList,
  errorSelected: SelectModal.errorSelected,
  errorUpdate: SelectModal.errorUpdate,
});

const mapDispatchToProps = dispatch => ({
  onSelectList: data => dispatch(selectModalList(data)),
  onSelectSelected: data => dispatch(selectModalSelected(data)),
  onSelectUpdate: data => dispatch(selectModalUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectModal));